import script from "./LaporansView.vue?vue&type=script&setup=true&lang=js"
export * from "./LaporansView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__